"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasourceFieldsQueryGrid = exports.FieldTextSearch = exports.ActionType = exports.ContentType = exports.mapResultNode = exports.searchDataGrid = exports.searchFieldDiv = exports.searchFieldFilter = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importStar(require("react"));
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const DatasourceFieldsDisplayGrid_1 = require("./DatasourceFieldsDisplayGrid");
exports.searchFieldFilter = (0, vizportalclient_common_components_1.cssClass)('search-field-filter', {
    display: 'flex',
    flexFlow: 'column',
    overflow: 'auto',
    alignSelf: 'flex-end',
});
exports.searchFieldDiv = (0, vizportalclient_common_components_1.cssClass)('search-field-div', {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 'inherit',
});
exports.searchDataGrid = (0, vizportalclient_common_components_1.cssClass)('search-data-grid', {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 'inherit',
});
function mapResultNode(field, resultData) {
    var _a, _b, _c;
    return {
        id: 'id' in field ? field.id : '',
        name: field.name,
        description: field.description,
        descriptionInherited: field.descriptionInherited,
        dataType: 'dataType' in field ? field.dataType : null,
        datasourceId: (_b = (_a = resultData.publishedDatasources) === null || _a === void 0 ? void 0 : _a[0].vizportalUrlId) !== null && _b !== void 0 ? _b : '',
        fieldIcon: (0, FieldFunctions_1.iconForField)(field),
        sheetCount: field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null,
        labels: field.__typename === 'ColumnField' ? (_c = field.columnsConnection) === null || _c === void 0 ? void 0 : _c.nodes.flatMap(t => t.labels) : [],
    };
}
exports.mapResultNode = mapResultNode;
var ContentType;
(function (ContentType) {
    ContentType["Datasource"] = "datasource";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var ActionType;
(function (ActionType) {
    ActionType["FieldSearch"] = "field_search";
    ActionType["ClearSearch"] = "clear_search";
    ActionType["ResetFilter"] = "reset_filter";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
function FieldTextSearch(props) {
    const [inProgressSearchText, setInProgressSearchText] = react_1.default.useState('');
    const sendFieldSearch = (0, data_catalog_shared_1.useTelemetrySender)({
        type: 'lineage_page_action',
        content_type: ContentType.Datasource,
        action_type: ActionType.FieldSearch,
    });
    const sendClearFieldSearch = (0, data_catalog_shared_1.useTelemetrySender)({
        type: 'lineage_page_action',
        content_type: ContentType.Datasource,
        action_type: ActionType.ClearSearch,
    });
    const sendResetFilter = (0, data_catalog_shared_1.useTelemetrySender)({
        type: 'lineage_page_action',
        content_type: ContentType.Datasource,
        action_type: ActionType.ResetFilter,
    });
    if (props.resetFilter.current) {
        setInProgressSearchText('');
        props.resetFilter.current = false;
        sendResetFilter();
    }
    return (react_1.default.createElement(widgets_1.TextFieldWidget, { "aria-label": catalog_messages_1.Messages.SearchLabel(), kind: 'search', label: '', onClear: () => {
            props.setSearchText('');
            setInProgressSearchText('');
            sendClearFieldSearch();
        }, onChange: (e) => {
            setInProgressSearchText(e.target.value);
        }, onKeyDown: (e) => {
            if (e.key === 'Enter') {
                props.setSearchText(inProgressSearchText);
                sendFieldSearch();
                props.setRowCount(-1);
            }
        }, placeholder: catalog_messages_1.Messages.EnterSearch(), testId: 'datasource-lineage-field-search', value: inProgressSearchText }));
}
exports.FieldTextSearch = FieldTextSearch;
function getSortByDisplayText(selectedSort) {
    if (selectedSort.direction === catalog_queries_1.OrderDirection.ASC) {
        if (selectedSort.field === catalog_queries_1.FieldOrderField.NAME) {
            return catalog_messages_1.Messages.SortByNameAsc();
        }
        else if (selectedSort.field === catalog_queries_1.FieldOrderField.DOWNSTREAM_SHEETS_COUNT) {
            return catalog_messages_1.Messages.SortByDownstreamSheetsAsc();
        }
    }
    else if (selectedSort.direction === catalog_queries_1.OrderDirection.DESC) {
        if (selectedSort.field === catalog_queries_1.FieldOrderField.NAME) {
            return catalog_messages_1.Messages.SortByNameDesc();
        }
        else if (selectedSort.field === catalog_queries_1.FieldOrderField.DOWNSTREAM_SHEETS_COUNT) {
            return catalog_messages_1.Messages.SortByDownstreamSheetsDesc();
        }
    }
    return '';
}
function getInitialSortMenuList(values) {
    const sortList = [{ value: catalog_messages_1.Messages.SortByDropdownSectionHeaderOrder(), group: true }];
    if (values.has(catalog_messages_1.Messages.GridHeaderName())) {
        sortList.push({ value: catalog_messages_1.Messages.sortByOrderAlphebeticalAZ() }, { value: catalog_messages_1.Messages.sortByOrderAlphebeticalZA() });
    }
    else if (values.has(catalog_messages_1.Messages.Sheets())) {
        sortList.push({ value: catalog_messages_1.Messages.MostToLeast() }, { value: catalog_messages_1.Messages.LeastToMost() });
    }
    sortList.push({ value: catalog_messages_1.Messages.SortByDropdownSectionHeaderOrder(), group: true }, {
        value: catalog_messages_1.Messages.GridHeaderName(),
    }, { value: catalog_messages_1.Messages.Sheets() });
    return sortList;
}
let nameColumnPrevSort = { direction: catalog_queries_1.OrderDirection.ASC, field: catalog_queries_1.FieldOrderField.NAME };
let currSortOrder = { direction: catalog_queries_1.OrderDirection.ASC, field: catalog_queries_1.FieldOrderField.NAME };
function getSelectedValues(order) {
    const selectedValues = new Set();
    if (order.field === catalog_queries_1.FieldOrderField.NAME && order.direction === catalog_queries_1.OrderDirection.ASC) {
        selectedValues.add(catalog_messages_1.Messages.GridHeaderName()).add(catalog_messages_1.Messages.sortByOrderAlphebeticalAZ());
    }
    else if (order.field === catalog_queries_1.FieldOrderField.NAME && order.direction === catalog_queries_1.OrderDirection.DESC) {
        selectedValues.add(catalog_messages_1.Messages.GridHeaderName()).add(catalog_messages_1.Messages.sortByOrderAlphebeticalZA());
    }
    else if (order.field === catalog_queries_1.FieldOrderField.DOWNSTREAM_SHEETS_COUNT && order.direction === catalog_queries_1.OrderDirection.ASC) {
        selectedValues.add(catalog_messages_1.Messages.Sheets()).add(catalog_messages_1.Messages.LeastToMost());
    }
    else if (order.field === catalog_queries_1.FieldOrderField.DOWNSTREAM_SHEETS_COUNT && order.direction === catalog_queries_1.OrderDirection.DESC) {
        selectedValues.add(catalog_messages_1.Messages.Sheets()).add(catalog_messages_1.Messages.MostToLeast());
    }
    return selectedValues;
}
function DatasourceFieldsQueryGrid(props) {
    const { searchAndFilterOnLineagePageEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const resetFilter = (0, react_1.useRef)(false);
    const [searchText, setSearchText] = react_1.default.useState('');
    const [gqlResultCount, setGqlResultCount] = react_1.default.useState(props.rowCount);
    const [sortValues, setSortValues] = react_1.default.useState(new Set([catalog_messages_1.Messages.sortByOrderAlphebeticalAZ(), catalog_messages_1.Messages.GridHeaderName()]));
    const sortList = getInitialSortMenuList(sortValues);
    const handleFilterChange = (value) => {
        const selectedValues = new Set(sortValues);
        switch (value) {
            case catalog_messages_1.Messages.sortByOrderAlphebeticalAZ():
                selectedValues.delete(catalog_messages_1.Messages.sortByOrderAlphebeticalZA());
                break;
            case catalog_messages_1.Messages.sortByOrderAlphebeticalZA():
                selectedValues.delete(catalog_messages_1.Messages.sortByOrderAlphebeticalAZ());
                break;
            case catalog_messages_1.Messages.MostToLeast():
                selectedValues.delete(catalog_messages_1.Messages.LeastToMost());
                break;
            case catalog_messages_1.Messages.LeastToMost():
                selectedValues.delete(catalog_messages_1.Messages.MostToLeast());
                break;
            case catalog_messages_1.Messages.Sheets():
                selectedValues.clear();
                selectedValues.add(catalog_messages_1.Messages.Sheets()).add(catalog_messages_1.Messages.MostToLeast());
                break;
            case catalog_messages_1.Messages.GridHeaderName():
                selectedValues.clear();
                selectedValues.add(catalog_messages_1.Messages.GridHeaderName()).add(catalog_messages_1.Messages.sortByOrderAlphebeticalAZ());
        }
        selectedValues.add(value);
        setSortValues(selectedValues);
    };
    // sort updated by name column
    if (props.orderBy !== nameColumnPrevSort) {
        currSortOrder = props.orderBy;
        nameColumnPrevSort = props.orderBy;
        setSortValues(getSelectedValues(currSortOrder));
    }
    else { // sort updated by dropdown
        if (sortValues.has(catalog_messages_1.Messages.GridHeaderName())) {
            if (sortValues.has(catalog_messages_1.Messages.sortByOrderAlphebeticalAZ())) {
                currSortOrder = { direction: catalog_queries_1.OrderDirection.ASC, field: catalog_queries_1.FieldOrderField.NAME };
            }
            else if (sortValues.has(catalog_messages_1.Messages.sortByOrderAlphebeticalZA())) {
                currSortOrder = { direction: catalog_queries_1.OrderDirection.DESC, field: catalog_queries_1.FieldOrderField.NAME };
            }
        }
        else if (sortValues.has(catalog_messages_1.Messages.Sheets())) {
            if (sortValues.has(catalog_messages_1.Messages.MostToLeast())) {
                currSortOrder = {
                    direction: catalog_queries_1.OrderDirection.DESC,
                    field: catalog_queries_1.FieldOrderField.DOWNSTREAM_SHEETS_COUNT,
                };
            }
            else {
                currSortOrder = {
                    direction: catalog_queries_1.OrderDirection.ASC,
                    field: catalog_queries_1.FieldOrderField.DOWNSTREAM_SHEETS_COUNT,
                };
            }
        }
    }
    return (react_1.default.createElement("div", { className: (0, data_catalog_shared_1.classes)(exports.searchFieldDiv) },
        react_1.default.createElement("div", { className: (0, data_catalog_shared_1.classes)(ColumnAndFieldDetailsStyles_1.searchFilterDiv) },
            searchAndFilterOnLineagePageEnabled && (react_1.default.createElement("span", { className: (0, data_catalog_shared_1.classes)(exports.searchFieldFilter) },
                catalog_messages_1.Messages.FieldFilterMessage(),
                react_1.default.createElement(FieldTextSearch, { setRowCount: setGqlResultCount, resetFilter: resetFilter, setSearchText: setSearchText }))),
            searchAndFilterOnLineagePageEnabled
                && (react_1.default.createElement("span", { className: (0, data_catalog_shared_1.classes)(ColumnAndFieldDetailsStyles_1.filterField) },
                    catalog_messages_1.Messages.SortByDropdownLabelText(),
                    react_1.default.createElement(widgets_1.MultiselectDropdownWidget, { type: widgets_1.DropdownButtonType.Line, label: '', list: react_1.default.createElement(widgets_1.List, { items: sortList }), value: sortValues, onChange: handleFilterChange }, getSortByDisplayText(currSortOrder))))),
        react_1.default.createElement("div", { className: (0, data_catalog_shared_1.classes)(exports.searchDataGrid) },
            react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.DatasourceFieldsByIdDocument, partialQueryVariables: {
                    vizportalUrlId: props.vizportalUrlId,
                    orderBy: currSortOrder,
                    searchText: searchText,
                }, selectConnectionListResult: (r) => r && r.publishedDatasources && r.publishedDatasources[0] && r.publishedDatasources[0].fieldsConnection, mapResultNode: mapResultNode, hackyUpdateNumber: props.hackyUpdateNumber, setRowCount: setGqlResultCount }, ({ rowStore }) => (react_1.default.createElement(DatasourceFieldsDisplayGrid_1.DatasourceFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: searchText === '' || !searchAndFilterOnLineagePageEnabled ? props.rowCount : gqlResultCount, orderBy: currSortOrder, updateSortOrder: props.updateSortOrder, resetFilter: () => {
                    setSearchText('');
                    resetFilter.current = true;
                } }))))));
}
exports.DatasourceFieldsQueryGrid = DatasourceFieldsQueryGrid;
//# sourceMappingURL=DatasourceFieldsQueryGrid.js.map